// extracted by mini-css-extract-plugin
export var base = "_50-0";
export var updateBanner = "_50-1";